import QRCode from 'qrcode';

import appError from '#shared/util/appError.js';

/**
 * Generate QR code
 * @param {object} canvas
 * @param {object} content - QR code content/text
 * @param {string} [content.spd = 1.0] - SPD - Short Payment Descriptor, QR code format
 * @param {string} [content.iban] - ACC - Account = IBAN + Swift
 * @param {string} [content.swiftCode] - ACC - Account = IBAN + Swift
 * @param {string} [content.amount] - AM - Amount
 * @param {string} [content.currency] - CC - Currency
 * @param {string} [content.message] - MSG - Message
 * @param {string} [content.variableSymbol = ''] - X-VS - Variable Symbol
 * @param {string} [content.specificSymbol = ''] - X-SS - Specific Symbol
 * @param {string} [content.constantSymbol = ''] - X-KS - Constant Symbol
 */
const qrCode = (canvas, { spd = '1.0', iban, swiftCode, amount, currency, message, variableSymbol = '', specificSymbol = '', constantSymbol = '' }) => {
	// Create correct format of QR code for wireTransfer
	let qrCodeContent = '';
	const qrCodeOptions = {
		margin: 1,
		width: 82
	};
	if (iban && swiftCode && amount && currency && message) {
		// Required QR code format
		qrCodeContent = `SPD*${spd}*ACC:${iban}+${swiftCode}*AM:${amount}*CC:${currency}*MSG:${message}`;
		// Add optional symbols (variable, specific, constant)
		if (variableSymbol) {
			qrCodeContent += `*X-VS:${variableSymbol}`;
		}
		if (specificSymbol) {
			qrCodeContent += `*X-SS:${specificSymbol}`;
		}
		if (constantSymbol) {
			qrCodeContent += `*X-KS:${constantSymbol}`;
		}
	}
	// Generate QR code
	QRCode.toCanvas(canvas, qrCodeContent, qrCodeOptions, (error) => {
		if (error) {
			throw appError(error, {
				code: 'APP_FRONTEND_UTIL',
				origin: 'qrCode',
				description: 'Could not generate QR code'
			});
		}
	});
};

export default qrCode;
